module.exports = __webpack_public_path__ + "img/frontIdCardImg.76884ec8.png";